/**
 * 准备分片数据
 * @param {Blob} chunk 分片数据
 * @returns {Promise<Uint8Array>}
 */
async function prepareChunkData(chunk) {
    if (chunk instanceof Blob) {
        const buffer = await chunk.arrayBuffer();
        return new Uint8Array(buffer);
    }
    return chunk;
}

module.exports = {
    prepareChunkData
};